import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Import components
import { Button } from 'components/elements';
import usePlayerContent from '../usePlayerContent';
import TopHeadline from 'components/elements/organisms/player_vod/PlayerWrapper/TopHeadline';

// Import styles
import { IconPlayStyled } from '../styles';

const TheoPlayerInner = ({ isFocus, type }) => {
	const { t } = useTranslation();
	const { error, handlePlayPause, showBigPlayButton } = usePlayerContent({
		type
	});

	return (
		<>
			<TopHeadline isFocus={isFocus} isError={error.isError} />
			{showBigPlayButton && (
				<Button
					modifiers={['icon', 'catchup', 'playerIconHover', 'playerPlay']}
					onClick={handlePlayPause}
					title={t('common_player_play_title')}
				>
					<IconPlayStyled
						aria-hidden="true"
						title={t('common_player_play_title')}
					/>
				</Button>
			)}
		</>
	);
};

TheoPlayerInner.propTypes = {
	type: PropTypes.string.isRequired,
	isFocus: PropTypes.bool.isRequired
};

export default TheoPlayerInner;
